import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  cancel: {
    id: 'jira-common.ListProjectForms.CopyModal.Cancel',
    defaultMessage: 'Cancel',
    description: 'Title of a Modal button for cancellation an action to copy a form between projects'
  },
  copy: {
    id: 'jira-common.ListProjectForms.CopyModal.Copy',
    defaultMessage: 'Copy',
    description: 'Title of a Modal button for starting the copy of a form between projects'
  },
  copyErrorTitle: {
    id: 'jira-common.ListProjectForms.CopyFormErrorTitle',
    defaultMessage: 'Error: Could not copy “{formName}” over',
    description: 'Title displayed when an error occurred when trying to copy a form over to one or more projects.'
  },
  copySuccessBusinessProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfBusinessProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to business projects.'
  },
  copySuccessBusinessProjectsTitle: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle',
    defaultMessage: 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
    description: 'Flag title displayed when a form has been successfully copied to business projects.'
  },
  copySuccessMultipleProjectTypesTitle: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle',
    defaultMessage: 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
    description: 'Flag title displayed when a form has been successfully copied to multiple project types.'
  },
  copySuccessOneProjectDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription',
    defaultMessage: '“{formName}” can now be used in “{projectName}”.',
    description: 'Flag description displayed when a form has been successfully copied to one project.'
  },
  copySuccessServiceAndBusinessProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to service and business projects.'
  },
  copySuccessServiceAndSoftwareProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to service and software projects.'
  },
  copySuccessServiceProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfServiceProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to service projects.'
  },
  copySuccessServiceProjectsTitle: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle',
    defaultMessage: 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
    description: 'Flag title displayed when a form has been successfully copied to service projects.'
  },
  copySuccessServiceSoftwareAndBusinessProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to service, software and business projects.'
  },
  copySuccessSoftwareAndBusinessProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to software and business projects.'
  },
  copySuccessSoftwareProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfSoftwareProjectsMessage}.',
    description: 'Flag description displayed when a form has been successfully copied to software projects.'
  },
  copySuccessSoftwareProjectsTitle: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle',
    defaultMessage: 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
    description: 'Flag title displayed when a form has been successfully copied to software projects.'
  },
  copySuccessUnrecognisedProjectsDescription: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription',
    defaultMessage: '“{formName}” can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.',
    description: 'Flag description displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
  },
  copySuccessUnrecognisedProjectsTitle: {
    id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle',
    defaultMessage: 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
    description: 'Flag title displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
  },
  copyToProjectsTitle: {
    id: 'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle',
    defaultMessage: 'Copy to project(s)',
    description: 'Title of a heading above the name of the projects where the form can be copied to'
  },
  heading: {
    id: 'jira-common.ListProjectForms.CopyModal.Heading',
    defaultMessage: 'Copy “{formName}” to other projects',
    description: 'Heading for a modal to copy a form between projects'
  },
  learnMore: {
    id: 'jira-common.ListProjectForms.CopyModal.LearnMore',
    defaultMessage: 'Learn more about copying forms',
    description: 'Title of a link button to trigger in app help about copying forms'
  },
  loadingProjects: {
    id: 'jira-common.ListProjectForms.CopyModal.LoadingProjects',
    defaultMessage: 'Loading projects',
    description: 'Message to display while the list of projects are being loaded'
  },
  name: {
    id: 'jira-common.ListProjectForms.CopyModal.Name',
    defaultMessage: 'Name',
    description: 'Title of a heading above the name of the form chosen to be copied between projects'
  },
  numberOfBusinessProjects: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects',
    defaultMessage: '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
    description: 'The number of business projects copied to. Only concatenated within forms copied to projects messages.'
  },
  numberOfServiceProjects: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects',
    defaultMessage: '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
    description: 'The number of service projects copied to. Only concatenated within forms copied to projects messages.'
  },
  numberOfSoftwareProjects: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects',
    defaultMessage: '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
    description: 'The number of software projects copied to. Only concatenated within forms copied to projects messages.'
  },
  selectAllProjects: {
    id: 'jira-common.ListProjectForms.CopyModal.SelectAllProjects',
    defaultMessage: 'Select all projects',
    description: 'Description for a checkbox to allow all projects in a list to be selected'
  },
  subHeading: {
    id: 'jira-common.ListProjectForms.CopyModal.SubHeading',
    defaultMessage: 'Changes made to a form are not reflected across any of its copies in other projects.',
    description: 'Subheading for a modal for copying a form between projects'
  }
});